// export const server_path = "http://44.205.211.62";

export const server_path = "https://habilis-kbr.com/backend-api";
// export const server_path = "http://54.147.79.5:5556";

// export const server_path = window.location.origin;


// let completePath = window.location.origin?.split(":");
// completePath.pop();

// export const server_path = completePath.join(":");

export function InvokeGetServiceCall(url) {
  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  return fetch(`${server_path}${url}`, requestOptions);
}

export function InvokePostServiceCall(url, requestBody) {
  const raw = JSON.stringify(requestBody);

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
    redirect: "follow",
  };
  return fetch(`${server_path}${url}`, requestOptions);
}
